var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-menu w-full px-5 hidden xl:flex items-center justify-end"})}
var staticRenderFns = []

export { render, staticRenderFns }